let canvas;
let ctx;
let scale = { x: 1, y: 1 };

export function init(el = "canvas") {
  canvas = document.querySelector(el);
  ctx = canvas.getContext("2d");

  return { canvas, ctx };
}

export function setScale(x, y) {
  const ctx = getContext();
  ctx.scale(x, y);
  scale = { x, y };
}

export function clear() {
  const ctx = getContext();
  const canvas = getCanvas();

  ctx.clearRect(0, 0, canvas.width, canvas.height);
}

export function loop(options) {
  function frame() {
    clear();

    options.update();

    requestAnimationFrame(frame);
  }

  function start() {
    requestAnimationFrame(frame);
  }

  return { start };
}

export function pool(objects = []) {
  const orig = objects;

  objects.forEach((obj) => add(obj));

  function add(obj) {
    if (exists(obj.x, obj.y)) {
      remove(obj.x, obj.y);
    }
    objects.push(obj);
  }

  function remove(x, y) {
    const index = objects.findIndex((obj) => {
      return obj.x === x && obj.y === y;
    });

    objects = [...objects.slice(0, index), ...objects.slice(index + 1)];
  }

  function pop() {
    objects.pop();
  }

  function empty() {
    objects = orig;
  }

  function exists(x, y) {
    return objects.some((obj) => obj.x === x && obj.y === y);
  }

  function update() {
    objects.forEach((obj) => obj.update());
  }

  return { add, remove, exists, empty, pop, update };
}

export function obj(options) {
  let attributes = {
    color: "#000",
    height: 1,
    width: 1,
    ...options,
    x: "x" in options ? Math.floor(options.x / scale.x) : null,
    y: "y" in options ? Math.floor(options.y / scale.y) : null,
    update,
  };

  const ctx = getContext();

  function render() {
    if (attributes.render) {
      return attributes.render(ctx, attributes);
    }

    ctx.fillStyle = attributes.color;
    ctx.fillRect(
      attributes.x,
      attributes.y,
      attributes.width,
      attributes.height
    );
  }

  function update() {
    if (attributes.x === null || attributes.y === null) return;

    render();
  }

  return attributes;
}

export function on(event, callback) {
  const canvas = getCanvas();

  canvas.addEventListener(event, callback);
}

export function off(event, callback) {
  const canvas = getCanvas();

  canvas.removeEventListener(event, callback);
}

export function getCanvas() {
  if (!canvas) throw "You must call init before accessing canvas";

  return canvas;
}

export function getContext() {
  if (!ctx) throw "You must call init before accessing canvas";

  return ctx;
}

export function downloadAsImage() {
  const canvas = getCanvas();
  var link = document.createElement("a");
  link.download = "sprite.png";
  link.href = canvas.toDataURL();
  link.click();
}
